import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { FaChevronLeft, FaChevronRight, FaCompress, FaExpand } from "react-icons/fa";
import { GuiasOverlay } from "./GuiasOverlay";
import { LAMINAS } from "./laminas";
import styles from "./Visor.module.scss";

function Visor() {
  const [index, setIndex] = useState(0);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const stageWrapRef = useRef(null);
  const total = LAMINAS.length;
  // Modo guía (Fase A, bases del sistema): ?guias=1 en la URL superpone líneas de centrado/margen.
  const mostrarGuias = useMemo(() => new URLSearchParams(window.location.search).get("guias") === "1", []);

  const goPrev = useCallback(() => {
    setIndex((current) => Math.max(0, current - 1));
  }, []);

  const goNext = useCallback(() => {
    setIndex((current) => Math.min(total - 1, current + 1));
  }, [total]);

  useEffect(() => {
    const onKeyDown = (event) => {
      if (event.key === "ArrowLeft") goPrev();
      if (event.key === "ArrowRight") goNext();
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [goPrev, goNext]);

  useEffect(() => {
    const onFullscreenChange = () => {
      setIsFullscreen(Boolean(document.fullscreenElement));
    };
    document.addEventListener("fullscreenchange", onFullscreenChange);
    return () => document.removeEventListener("fullscreenchange", onFullscreenChange);
  }, []);

  const toggleFullscreen = () => {
    if (!stageWrapRef.current) return;
    if (document.fullscreenElement) {
      document.exitFullscreen();
    } else {
      stageWrapRef.current.requestFullscreen();
    }
  };

  const ActiveLamina = LAMINAS[index].Component;
  const progressPct = total > 1 ? ((index + 1) / total) * 100 : 100;

  return (
    <div className={styles.viewer}>
      <div className={styles.stageWrap} ref={stageWrapRef}>
        <div className={styles.stage}>
          <ActiveLamina />
          <div className={styles.stripe} />
          {mostrarGuias && <GuiasOverlay columnas={LAMINAS[index].columnas} />}
        </div>

        <div className={styles.progressTrack}>
          <div className={styles.progressFill} style={{ width: `${progressPct}%` }} />
        </div>

        <div className={styles.controls}>
          <button
            type="button"
            className={styles.navButton}
            onClick={goPrev}
            disabled={index === 0}
            aria-label="Lámina anterior"
          >
            <FaChevronLeft />
          </button>

          <span className={styles.counter}>
            {index + 1} / {total}
          </span>

          <button
            type="button"
            className={styles.navButton}
            onClick={goNext}
            disabled={index === total - 1}
            aria-label="Lámina siguiente"
          >
            <FaChevronRight />
          </button>

          <button
            type="button"
            className={styles.fullscreenButton}
            onClick={toggleFullscreen}
            aria-label={isFullscreen ? "Salir de pantalla completa" : "Pantalla completa"}
          >
            {isFullscreen ? <FaCompress /> : <FaExpand />}
          </button>
        </div>
      </div>
    </div>
  );
}

export default Visor;
